<template>
    <svg stroke="currentColor"
         viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg">
        <g class="spinner_V8m1">
            <circle cx="12"
                    cy="12"
                    fill="none"
                    r="9.5"
                    stroke-width="3" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'spinner'
}
</script>

<style>

.spinner_V8m1 {
    --spinner-animation-duration: 2.5s;
    transform-origin: center;
    animation: spinner_zKoa var(--spinner-animation-duration) linear infinite, anim-fade-in 800ms;
}

.spinner_V8m1 circle {
    stroke-linecap: round;
    animation: spinner_YpZS calc(var(--spinner-animation-duration) * 3 / 4) ease-in-out infinite
}

@keyframes spinner_zKoa {
    100% {
        transform: rotate(360deg)
    }
}

@keyframes spinner_YpZS {
    0% {
        stroke-dasharray: 0 150;
        stroke-dashoffset: 0
    }
    47.5% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -16
    }
    95%, 100% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -59
    }
}
</style>
